import React from 'react';
export function Footer() {
  return <footer className="bg-[#0A1F33] text-white/70 py-16 px-4 sm:px-6 lg:px-8 border-t border-white/10" data-id="element-581" data-mp="32wd2cf6gdjt0">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8" data-id="element-582" data-mp="3ggk8mvu5ve02">
        {/* Column 1 */}
        <div className="lg:pr-8" data-id="element-583" data-mp="36pfutzg81z6t">
          <img src="https://cdn.magicpatterns.com/uploads/pa3Fk96C6qU6AFqdF9EfnU/ChatGPT_Image_Aug_25,_2026,_10_57_05_AMff.png" alt="SyNeural — Creating an Intelligent Web" className="h-10 w-auto mb-5 brightness-0 invert" data-id="element-584" data-mp="36qhhl16loa4d" />
          <p className="text-sm leading-relaxed" data-id="element-585" data-mp="3lem0o69kenno">
            Building better judgment for a more capable society.
          </p>
        </div>

        {/* Column 2 */}
        <div data-id="element-586" data-mp="3qfjj8jyhljpp">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-587" data-mp="3qf9nsguoakcm">
            Products
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-588" data-mp="2eyjq5m4bf0um">
            <li data-id="element-589" data-mp="2ew6zmkkhri5y">
              <a href="#human-capability" className="hover:text-white transition-colors" data-id="element-590" data-mp="3l9k5dbpy7lcr">
                Human Capability Platform
              </a>
            </li>
            <li data-id="element-591" data-mp="3v7gg42ez4eac">
              <a href="#cji" className="hover:text-white transition-colors pl-3" data-id="element-592" data-mp="3v7zx9gwsuynb">
                CJI
              </a>
            </li>
            <li data-id="element-593" data-mp="3q7bw42eux1fd">
              <a href="#ncji" className="hover:text-white transition-colors pl-3" data-id="element-594" data-mp="3qapwx67vh2kp">
                NCJI
              </a>
            </li>
            <li data-id="element-595" data-mp="34gt971ke92u">
              <a href="#semantic-knowledge" className="hover:text-white transition-colors" data-id="element-596" data-mp="32w45wy0ricd">
                Semantic Knowledge Platform
              </a>
            </li>
            <li data-id="element-597" data-mp="cu8sieklzqdn">
              <a href="#solutions" className="hover:text-white transition-colors" data-id="element-598" data-mp="cvtn246xb9bi">
                Solutions
              </a>
            </li>

          </ul>
        </div>

        {/* Column 3 */}
        <div data-id="element-599" data-mp="tvmodc6um6j9">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-600" data-mp="tw5wk16p5gk3">
            Applications
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-601" data-mp="ys3fmf9ch10k">
            <li data-id="element-602" data-mp="13t0uahv5bcxb">
              <a href="#education" className="hover:text-white transition-colors" data-id="element-603" data-mp="13sipgwuf3qds">
                Education
              </a>
            </li>
            <li data-id="element-604" data-mp="1ckkocqou8yly">
              <a href="#employers" className="hover:text-white transition-colors" data-id="element-605" data-mp="1cl2t6bpkgl5h">
                Employers
              </a>
            </li>
            <li data-id="element-606" data-mp="1ml3gs9ugxnfh">
              <a href="#civil-society" className="hover:text-white transition-colors" data-id="element-607" data-mp="1mkjwimhcimya">
                Civil Society
              </a>
            </li>
            <li data-id="element-608" data-mp="3oczpzct5yl73">
              <a href="#government" className="hover:text-white transition-colors" data-id="element-609" data-mp="3od80wz5q7gfn">
                Government
              </a>
            </li>
            <li data-id="element-610" data-mp="2ah84uvf2t8uz">
              <a href="#leadership" className="hover:text-white transition-colors" data-id="element-611" data-mp="25of1aavcg6kh">
                Leadership
              </a>
            </li>
          </ul>
        </div>

        {/* Column 4 */}
        <div data-id="element-612" data-mp="1worxjif56oo9">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-613" data-mp="1wpa2r4js8d8b">
            Company
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-614" data-mp="2tbn2ohpnivh8">
            <li data-id="element-615" data-mp="2pdfqm064uicd">
              <a href="#about" className="hover:text-white transition-colors" data-id="element-616" data-mp="2pcw4065jf5s0">
                About
              </a>
            </li>
            <li data-id="element-617" data-mp="2fe6y7bqx1bs4">
              <a href="#research" className="hover:text-white transition-colors" data-id="element-618" data-mp="2fegm8tseh8v6">
                Research
              </a>
            </li>
            <li data-id="element-619" data-mp="13z1klcp8xstq">
              <a href="#partnerships" className="hover:text-white transition-colors" data-id="element-620" data-mp="13yiagi5u88q9">
                Partnerships
              </a>
            </li>
            <li data-id="element-621" data-mp="2wmzjiis06nw7">
              <a href="#contact" className="hover:text-white transition-colors" data-id="element-622" data-mp="2wnhlzx59dyck">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-white/10 text-xs flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-623" data-mp="2ntmg2mwbc3vv">
        <p data-id="element-624" data-mp="3bki3z8xneexu">&copy; {new Date().getFullYear()} SyNeural. All rights reserved.</p>
        <div className="flex gap-6" data-id="element-625" data-mp="3fk0pa5tdss17">
          <a href="#privacy" className="hover:text-white transition-colors" data-id="element-626" data-mp="3fizd1y0mpzhw">
            Privacy Policy
          </a>
          <a href="#terms" className="hover:text-white transition-colors" data-id="element-627" data-mp="36kng7e9665h0">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>;
}